const LAY_DANH_SACH_BAO_CAO_TABLE = (state, danhSachBaoCaoTable) => {
  state.danhSachBaoCaoTable = danhSachBaoCaoTable;
};

const LAY_DANH_SACH_BAO_CAO_VAN_BAN_DI_TABLE = (
  state,
  danhSachBaoCaoVanBanDiTable
) => {
  state.danhSachBaoCaoVanBanDiTable = danhSachBaoCaoVanBanDiTable;
};

export default {
  LAY_DANH_SACH_BAO_CAO_TABLE,
  LAY_DANH_SACH_BAO_CAO_VAN_BAN_DI_TABLE,
};
